import { nextTick } from 'vue';

export const autofocus = {
  mounted(el) {
    nextTick(() => {
      el.focus();
    });
  },
};
